/* global axios */
import ApiClient from '../ApiClient';

class PilotWechatCrawl extends ApiClient {
  constructor() {
    super('pilot/knowledge_bases', { accountScoped: true });
  }

  show(knowledgeBaseId, scope) {
    const params = scope ? { scope } : {};
    return axios.get(`${this.url}/${knowledgeBaseId}/wechat_crawl`, { params });
  }

  create(knowledgeBaseId, data) {
    return axios.post(`${this.url}/${knowledgeBaseId}/wechat_crawl`, data);
  }

  update(knowledgeBaseId, data) {
    return axios.put(`${this.url}/${knowledgeBaseId}/wechat_crawl`, data);
  }

  delete(knowledgeBaseId, scope) {
    const params = scope ? { scope } : {};
    return axios.delete(`${this.url}/${knowledgeBaseId}/wechat_crawl`, {
      params,
    });
  }
}

export default new PilotWechatCrawl();
